import { POLAR_VIEW, CHURCHILL_BRAND, ICE_DRIFT_BRAND } from './services'

// development options
export const DEBUG = process.env.NODE_ENV === 'development'
export const PRODUCTION = process.env.NODE_ENV === 'development'
// export const DEBUG = true

// map defaults
// C-CORE, St. John's
// export const LATITUDE = 47.575777
// export const LONGITUDE = -52.734621
// Nain, NL
// export const LATITUDE = 56.542
// export const LONGITUDE = -61.697
// MOPRA
// export const LATITUDE = 50.49
// export const LONGITUDE = -111.993
// Ice Drift
// export const LATITUDE = 72.72476
// export const LONGITUDE = -74.6495
// River Ice
// export const LATITUDE = 56.73
// export const LONGITUDE = -111.38
// Inland Waters
// export const LATITUDE = 61.667
// export const LONGITUDE = -114
// Clyde River
const CLYDE_RIVER_LATITUDE = 70.35
const CLYDE_RIVER_LONGITUDE = -69.7
const CHURCHILL_RIVER_LATITUDE = 53.35
const CHURCHILL_RIVER_LONGITUDE = -60.5059
// Buttonwillow
export const LATITUDE = 35.3
export const LONGITUDE = -119.6
export const CENTER = POLAR_VIEW ?
  [CLYDE_RIVER_LONGITUDE, CLYDE_RIVER_LATITUDE]
  : ICE_DRIFT_BRAND ?
  [-101, 73]
  : CHURCHILL_BRAND ?
  [CHURCHILL_RIVER_LONGITUDE, CHURCHILL_RIVER_LATITUDE]
  :[LONGITUDE, LATITUDE]
export const ZOOM = ICE_DRIFT_BRAND ? 3.5 : 8
export const PITCH = 0
export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiYy1jb3JlIiwiYSI6ImNqZWl3bzI0MzBsNm4zM21lcjBsZXpvajUifQ.gmSOoJC8y-fk9rNz88-gTg'

// auth0
export const AUDIENCE = POLAR_VIEW
  ? 'https://coresight.auth0.com/userinfo'
  : 'https://login.looknorthservices.com/userinfo'
// export const AUDIENCE = 'https://coresight.auth0.com/userinfo'
// export const AUDIENCE = 'https://login.looknorthservices.com/userinfo'
export const CLIENT_ID = 'UG38nqPEva7g2MajD6erGFMGJa7Tfzcz'
export const CONNECTION = 'Username-Password-Authentication'
export const DOMAIN = POLAR_VIEW
  ? 'coresight.auth0.com'
  : 'login.looknorthservices.com'
// export const DOMAIN = 'coresight.auth0.com'
// export const DOMAIN = 'login.looknorthservices.com'
export const REDIRECT_URI = window.location.origin + window.location.pathname
export const RESPONSE_TYPE = 'token id_token'
export const SCOPE =
  'openid nickname name https://auth0.looknorthservices.com/v1/permissions'
export const AUTH0_OPTIONS = {
  allowedConnections: ['Username-Password-Authentication', 'google-oauth2'],
  avatar: null,
  rememberLastLogin: true,
  socialButtonStyle: 'small',
  theme: {
    primaryColor: '#2284DE'
  },
  loginAfterSignUp: false,
  allowSignUp: false,
  autoclose: false,
  languageDictionary: {
    title: ''
  },
  auth: {
    redirect: false,
    responseType: 'code',
    sso: false,
    params: {
      scope:
        'openid nickname name permissions last_login logins_count email_verified user_metadata'
    }
  },
  language: 'en'
}

export const SATELLITE_BASEMAP_TOGGLE_URL = (x, y, z) =>
  `https://a.tiles.mapbox.com/v4/mapbox.satellite/${Math.trunc(
    z
  )}/${x}/${y}.webp?access_token=${MAPBOX_ACCESS_TOKEN}`
export const STREET_BASEMAP_TOGGLE_URL = (x, y, z) =>
  `https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/${Math.trunc(
    z
  )}/${x}/${y}?access_token=${MAPBOX_ACCESS_TOKEN}`
export const SATELLITE_BASEMAP_STYLE = 'mapbox://styles/mapbox/satellite-streets-v9'
// export const SATELLITE_BASEMAP_STYLE = 'mapbox://styles/mapbox/landsat-live'
// export const STREET_BASEMAP_STYLE = 'mapbox://styles/mapbox/streets-v9'
// export const STREET_BASEMAP_STYLE = 'mapbox://styles/mapbox/outdoors-v9'
export const STREET_BASEMAP_STYLE = 'mapbox://styles/mapbox/light-v9'

export const EXCLUDE_FROM_TIMESLIDER = [
  'Sentinel1',
  'Sentinel1Wms',
  'Sentinel2',
  'Modis',
  'CmemsSeaIce',
  'CmemsSnowThickness'
]

export const ALLOW_GUEST = window.location.hostname.includes('smartice') ? false :
  window.location.hostname.includes('energir') ? false : true

export const PLANET_API_KEY = 'c93217084d874198991837b45be28f49'

export const SENTINEL_KEY = '6179cd9a-6ff5-43a5-8f01-8aef07e9f211'

// Marcia Angell opioid use history, from Thomas Jefferson's 18th century tincture of opium fondness to aggressive marketing of OxyContin in 90s and street use of fentanyl today. Opioid crisis is a problem of law and medicine, but also of politics. @johnrockdoc
// https://www.nybooks.com/articles/2018/12/06/opioid-nation/



// WEBPACK FOOTER //
// ./src/config/constants.js